const user = {
   firstName: '',
   lastName: '',
   email: '',
   additionalInformation: {
      phone: '',
      verifiedPhone: null,
      cpf: '',
      gender: '',
      countryCod: '+55',
      businessName: '',
      corporateName: '',
      type: ''
   },
   address: {
      cep: '',
      street: '',
      number: '',
      complement: '',
      district: '',
      state: '',
      city: '',
   },
   avatar: {
      filename: '',
      destination: '',
      mimetype: '',
   },
   description: '',
   social: null
};

export default user;
